export default "__VITE_ASSET__DOedEcO2__"